import React from 'react';

export default function useModal<T>() {
  const [isShow, setIsShow] = React.useState(false);
  const [data, setData] = React.useState<T>();

  const close = () => setIsShow(false);

  const open = (pData?: T) => {
    setData(pData);
    setIsShow(true);
  };

  const toggle = () => setIsShow((prev) => !prev);

  return {
    isShow,
    setIsShow,
    data,
    setData,
    close,
    open,
    toggle,
  };
}
